import { useMutation, useQueryClient } from '@tanstack/react-query'

import { login } from './auth.service'

export const useLogin = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: login,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['customerAccountData'],
      })
    },
  })
}
